(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('HelperService', HelperService)

    /** @ngInject */
    function HelperService($timeout, $state, $rootScope, $q, sweetAlert, ValidationMessageService, NotifyService, ProductService, AuthenticationService, AUTH_EVENTS, ROUTES) {
        const HelperService = {
            tryParseJSON: tryParseJSON,
            handleOnRun: handleOnRun,
            handleLocationChangeStart: handleLocationChangeStart,
            handleStateChangeStart: handleStateChangeStart,
            handleStateChangeSuccess: handleStateChangeSuccess,
            handleStateChangeError: handleStateChangeError,
            handleViewContentLoaded: handleViewContentLoaded,
            errorCallback: errorCallback,
            successCallback: successCallback,
            startLoading: startLoading,
            stopLoading: stopLoading,
            setErrorMessageForm: setErrorMessageForm,
            removeErrorMessageForm: removeErrorMessageForm,
            isScreenSmaller: isScreenSmaller,
            uiCanExit: uiCanExit,
            showModal: showModal,
            hideModal: hideModal,
            imageFolderPath: imageFolderPath,
            imageHandlerPath: imageHandlerPath,
            scrollTo: scrollTo
        };

        return HelperService;

        function imageFolderPath(area, id, file) {
            return `${ROUTES.API}/Assets/Uploads/${area}/${id}/${file}`;
        }

        function imageHandlerPath(area, id, file) {
            return `${ROUTES.API}/images/res/${area}/${id}/${file}`;
        }

        function uiCanExit(originalData, compareData) {
            let defer = $q.defer();

            let showModal = () => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Você irá perder as alterações que executou',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value)
                        defer.resolve(true);
                    else
                        defer.resolve(false);
                })
            }

            if (originalData && originalData.constructor === Array && compareData && compareData.constructor === Array) {
                let hasDiff = false;

                for (let index = 0; index < originalData.length; index++) {
                    const data = originalData[index];

                    if (compareData[index] && !angular.equals(data, compareData[index])) {
                        hasDiff = true;
                        showModal();
                    }
                }

                if (!hasDiff)
                    defer.resolve(true);
            } else {
                if (!angular.equals(originalData, compareData))
                    showModal();
                else
                    defer.resolve(true);
            }

            return defer.promise;
        }

        /**
         * Tries to parse a JSON string
         * 
         * @param {string} jsonString - String to be parsed
         */
        function tryParseJSON(jsonString) {
            try {
                var o = JSON.parse(jsonString);

                // Handle non-exception-throwing cases:
                // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
                // but... JSON.parse(null) returns null, and typeof null === "object",
                // so we must check for that, too. Thankfully, null is falsey, so this suffices:
                if (o && typeof o === 'object')
                    return o;
            } catch (e) {
                return false;
            }

            return false;
        }

        /**
         * Auxiliar method to prevent state and location change if there's a sweet alert modal open
         * 
         * @param {object} event - The current event
         */
        function handleLocationChangeStart(event) {
            if ($rootScope.isSweetAlertModalOpen)
                event.preventDefault();
        }

        /**
         * Auxiliar method to execute the necessary methods on the route change start
         * 
         * @param {object} transition - The executing transition
         */
        function handleStateChangeStart(transition) {
            const nextUrl = transition.to().url;

            if (transition.to().name.indexOf('auth') >= 0)
                return transition;

            if (nextUrl.indexOf('not-authorized') >= 0 && AuthenticationService.isLogged())
                return transition;

            if (!AuthenticationService.isLogged()) {
                AuthenticationService.logout();
                return false;
            }

            if (!AuthenticationService.canAccess(transition.to()))
                return transition.router.stateService.transitionTo('not-authorized');

            if (!ProductService.cartIsValid())
                ProductService.clearProducts();

            if (isScreenSmaller(991) && $('.header-collapse .collapse').hasClass('show'))
                $('.header-collapse .collapse').collapse('hide');

            return transition;
        }

        /**
         * Auxiliar method executed on every route state successfull change
         */
        function handleStateChangeSuccess() {
            $('.modal-backdrop').remove();

            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }

        /**
         * Auxiliar method executed once the system has finished loading all of it's content
         */
        function handleViewContentLoaded() {

        }

        /**
         * Auxiliar method executed when the system is starting
         */
        function handleOnRun() {
            //Comment this to exit errors related to transition and/or transition related services like User or Menu
            // $state.defaultErrorHandler(angular.noop);

            $rootScope.isSweetAlertModalOpen = false;
            $rootScope.removeMessage = removeErrorMessageForm;

            $rootScope.isMobile = isScreenSmaller(991);

            $rootScope.currentYear = moment().format('YYYY');
            $rootScope.ValidationMessage = ValidationMessageService.getMessage;

            $rootScope.$on(AUTH_EVENTS.NOT_AUTHENTICATED, AuthenticationService.logout);
        }

        /**
         * Auxiliar method executed when the route change fails
         *
         * @param {object} error - The transition error
         */
        function handleStateChangeError(error) {
            console.log('error: ', error);
            console.log('$state.current: ', $state.current);
            if (error && error.redirTo)
                $state.go(error.redirTo);
        }

        function isScreenSmaller(size) {
            return Modernizr.mq(`(max-width: ${size}px)`);
        }

        function errorCallback(error) {
            let message = 'Ocorreu um erro inesperado, por favor tente novamente!';

            if (error && error.data && error.data.ErrorCode) {
                if (error.data.ErrorCode == 404 || error.data.ErrorCode == 409)
                    message = error.data.ErrorMessage || 'Ocorreu um erro inesperado, por favor tente novamente!';

                else if (error.data.ErrorCode == 422) {
                    const errorMessage = error.data.ErrorMessage;
                    let parsedErrorMessage;

                    if (typeof errorMessage === 'string')
                        parsedErrorMessage = tryParseJSON(errorMessage);

                    if (typeof parsedErrorMessage === typeof []) {
                        let messages = parsedErrorMessage;
                        message = '';

                        if (messages) {
                            for (let i = 0; i < messages.length; i++)
                                message += messages[i].ErrorMessage;
                        }
                    } else
                        message = errorMessage;
                }
            } else if (error && error.data && error.data.error && error.data.error_description) {
                if (error.data.error == 'invalid_grant')
                    message = error.data.error_description;
            }

            NotifyService.error(message);
        }

        function successCallback(type = 'create') {
            let message = '';

            if (type == 'create')
                message = 'Registro salvo com sucesso';

            else if (type == 'update')
                message = 'Registro atualizado com sucesso';

            else if (type == 'delete')
                message = 'Registro apagado com sucesso';

            NotifyService.success(message);
        }

        function startLoading(element, smaller = false) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');
                let smallerClass = '';

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                if (smaller)
                    smallerClass = 'smaller';

                widget.append(`<div class="loading-body ${smallerClass}">
                                <img src="/app/dist/images/progress-circle-complete.svg" alt="Carregando, aguarde...">
                            </div>`);
            })
        }

        function stopLoading(element) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                widget
                    .find('.loading-body')
                    .fadeOut(function () {
                        $(this).remove();
                    });
            })
        }

        function setErrorMessageForm(input, text = null, scrollToElement = true) {
            if (!$(input).parent().find('.validationMessage').length) {

                let errorText = "Este campo é Obrigatório"

                if (text != null)
                    errorText = text;

                $(input).parent()
                    .append(`<label class=\'control-label has-error validationMessage\'>${errorText}</label>`);

                $(input)
                    .addClass('has-error')
                    .parents('.form-group')
                    .addClass('has-error');
            }

            if (scrollToElement) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
                }, 600);
            }
        }

        function removeErrorMessageForm(input) {
            $(input)
                .parent()
                .find('.validationMessage')
                .remove();

            $(input)
                .removeClass('has-error')
                .parents('.form-group')
                .removeClass('has-error');
        }

        function showModal(modal) {
            if (!$(modal).length)
                return;

            $(modal).modal('show');
        }

        function hideModal(modal) {
            if (!$(modal).length)
                return;

            $(modal).modal('hide');
        }

        function scrollTo(navTo, offset = 0) {
            $('html, body').animate({
                scrollTop: ($(navTo).offset().top - ($('.header').outerHeight()) - offset)
            }, 600);
        }
    }
}());